<template lang="pug">
v-card
    v-toolbar(flat dense)
        v-tabs(v-model="tab")
            v-tab Token Marketplace
            v-tab Points Marketplace
            v-tab Item Database
            v-tab Redeem Lists

    v-tabs-items(v-model="tab")
        marketplace-lists(type="Token")
        marketplace-lists(type="Points")
        item-database-lists(@success="successMessage = true" @error="onError")
        redeem-lists

    v-snackbar(top v-model="successMessage" color="success") Successfully Saved!
    v-snackbar(top v-model="error.show" color="red") {{ error.message }}
</template>

<script>
import MarketplaceLists from './components/MarketplaceLists'
import ItemDatabaseLists from './components/ItemDatabaseLists'
import RedeemLists from './components/RedeemLists.vue'

export default {
    data() {
        return {
            tab: null,

            successMessage: false,
            error: {
                show: false,
                message: ''
            }
        };
    },
    methods: {
        onError(err) {
            this.error.show = true;
            this.error.message = err.message;
        }
    },
    components: {
        MarketplaceLists,
        ItemDatabaseLists,
        RedeemLists
    }
}
</script>